import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { Category } from '@freelancer/datastore/collections';
import { HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { ListItemPadding } from '@freelancer/ui/list-item';
import { TextSize } from '@freelancer/ui/text';
import { Observable } from 'rxjs';
import { getSkillCategoryIcon } from '../skills.config';

@Component({
  selector: 'fl-skills-categories',
  template: `
    <fl-heading
      class="SkillsCategoryHeading"
      i18n="Skill categories heading"
      [headingType]="HeadingType.H3"
      [size]="TextSize.XSMALL"
    >
      Select a category
    </fl-heading>

    <fl-scrollable-content class="SkillsCategoryList">
      <fl-list
        [clickable]="true"
        [padding]="ListItemPadding.SMALL"
      >
        <ng-container *ngIf="categories$ | flAsync as categories; else loading">
          <fl-list-item
            *ngFor="let category of categories; trackBy: trackByCategoryId"
            flTrackingLabel="SelectCategory"
            (click)="handleSelectedCategory(category)"
          >
            <div class="SkillsCategory">
              <div
                class="SkillsCategory-content"
                [flMarginRight]="'mid'"
              >
                <fl-icon
                  [name]="getSkillCategoryIcon(category)"
                  [color]="IconColor.SECONDARY"
                  [flMarginRight]="'small'"
                ></fl-icon>

                <p>
                  {{ category.name }}
                </p>
              </div>

              <fl-icon
                [name]="'ui-arrow-right-alt'"
                [size]="IconSize.XSMALL"
              ></fl-icon>
            </div>
          </fl-list-item>
        </ng-container>

        <ng-template #loading>
          <fl-spinner
            class="SkillsCategoryList-loading"
            flTrackingLabel="SkillsCategoriesLoadingSpinner"
          ></fl-spinner>
        </ng-template>
      </fl-list>
    </fl-scrollable-content>
  `,
  styleUrls: ['./skills-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillsCategoriesComponent {
  HeadingType = HeadingType;
  IconColor = IconColor;
  IconSize = IconSize;
  ListItemPadding = ListItemPadding;
  TextSize = TextSize;

  @Input() categories$: Observable<readonly Category[]>;
  @Output() selectCategory = new EventEmitter<Category>();

  getSkillCategoryIcon(category: Category): string {
    return getSkillCategoryIcon(category);
  }

  handleSelectedCategory(category: Category): void {
    this.selectCategory.emit(category);
  }

  trackByCategoryId(index: number, category: Category): number {
    return category.id;
  }
}
